import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 21 20"
    >
      <g id="Icon" fillRule="evenodd" clipRule="evenodd">
        <path
          id="Icon_2"
          fill={colorValue}
          d="M3 11.875c.345 0 .625.28.625.625 0 1.196.001 2.03.086 2.66.082.611.233.935.463 1.166s.555.38 1.166.463c.63.085 1.464.086 2.66.086h5c1.196 0 2.03-.001 2.66-.086.611-.082.935-.233 1.166-.463s.38-.555.463-1.166c.085-.63.086-1.464.086-2.66a.625.625 0 1 1 1.25 0v.046c0 1.14 0 2.058-.097 2.78-.1.75-.317 1.382-.818 1.884-.502.501-1.134.717-1.884.818-.722.097-1.64.097-2.78.097H7.954c-1.14 0-2.058 0-2.78-.097-.75-.1-1.382-.317-1.884-.818-.501-.502-.717-1.133-.818-1.884-.097-.722-.097-1.64-.097-2.78V12.5c0-.345.28-.625.625-.625"
        ></path>
        <path
          id="Icon_3"
          fill={colorValue}
          d="M10.5 1.875c.175 0 .343.074.461.203l3.334 3.646a.625.625 0 1 1-.923.844L11.125 4.11v9.223a.625.625 0 0 1-1.25 0V4.11L7.628 6.568a.625.625 0 1 1-.923-.844l3.334-3.646a.63.63 0 0 1 .461-.203"
        ></path>
      </g>
    </svg>
  );
};
